const QrCode = {
  getQrCode: (paymentId: string) => `/Payment/QrCode?paymentid=${paymentId}`,
};

export default QrCode;
